export default __webpack_public_path__ + "static/media/atg.beb03cca.png";